module.exports = __webpack_public_path__ + "media/images/pic/hero/lion-95abe47fc1a7880c2107f028cbae369f.png";